import React from "react";
import { PAGES, PERMISSION_DATA } from "../../../lib/const";
import usePermission from "../../../lib/hooks/usePermisson";
import Content from "./components/content";
import Search from "./components/search";

const CurrentCustomer = () => {
  const [roleUser, isAll] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.CURRENT_CUSTOMER
  );

  return (
    <>
      <Search roleUser={roleUser} />
      <Content roleUser={roleUser} />
    </>
  );
};

export default CurrentCustomer;
